export default __webpack_public_path__ + "static/media/blackFriday.43d823d6.png";